<template>
  <v-card fill-height>
    <v-layout row wrap>
          <!--<v-flex md12>
            <BtnDownloadExcel :balance="balance" :configExcel="configExcel"></BtnDownloadExcel>
          </v-flex>-->
          <v-flex md12>
            <v-layout row justify-start wrap>
              <v-flex xs12 sm12 md6 lg4 class="hidden-xs-only">
                <v-card class="text-xs-left" flat color="">
                  <v-card-title class="body-2 font-weight-bold pb-2">
                    <span v-html="scoreTitle"></span>
                  </v-card-title>
                  <v-card-text class="pt-0 font-weight-bold">
                    <table class="a">
                      <tr v-if="nameMother">
                        <td class="lineheighttd">
                          {{'BANKENSCORE_NAME'| translate}}
                        </td>
                        <td class="lineheighttd tabelBanscoText">
                          {{nameMother}}
                        </td>
                      </tr>
                      <tr v-if="bankenscoreYear">
                        <td class="lineheighttd">
                          {{'BANKENSCORE_YEAR'| translate}}
                        </td>
                        <td class="lineheighttd tabelBanscoText">
                          {{bankenscoreYear}}
                        </td>
                      </tr>
                      <tr v-if="waText">
                        <td class="lineheighttd">
                          {{'BANKENSCORE_WA'| translate}}
                        </td>
                        <td class="lineheighttd tabelBanscoText">
                          {{waText}}
                        </td>
                      </tr>
                      <tr v-if="rechtskreisText">
                        <td class="lineheighttd">
                          {{'BANKENSCORE_RECHTSKREIS'| translate}}
                        </td>
                        <td class="lineheighttd tabelBanscoText">
                          {{rechtskreisText}}
                        </td>
                      </tr>
                    </table>
                  </v-card-text>
                  <v-card-text class="textleft pt-0 font-weight-bold">
                    <span v-html="scoreText1"></span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md7 lg6 class="hidden-sm-and-up">
                <v-card class="text-xs-left" flat color="">
                  <v-card-title class="body-2 font-weight-bold pb-2">
                    <span v-html="scoreTitle"></span>
                  </v-card-title>
                  <v-card-text class="pt-0 font-weight-bold">
                    <tr>
                      <td>
                        <span v-if="nameMother">{{'BANKENSCORE_NAME'| translate}}</span><br>
                        <span v-if="bankenscoreYear">{{'BANKENSCORE_YEAR'| translate}}</span><br>
                        <span v-if="waText">{{'BANKENSCORE_WA'| translate}}</span><br>
                        <span v-if="rechtskreisText">{{'BANKENSCORE_RECHTSKREIS'| translate}}</span>
                      </td>
                      <td class="pl-3" style="width: 200px; white-space: nowrap; text-overflow: ellipsis;">
                        <span style="font-weight: lighter;">{{nameMother}}</span> <br>
                        <span style="font-weight: lighter;">{{bankenscoreYear}}</span><br>
                        <span style="font-weight: lighter;">{{waText}}</span> <br>
                        <span style="font-weight: lighter;">{{rechtskreisText}}</span>
                      </td>
                    </tr>
                  </v-card-text>
                  <v-card-text class="pt-0 font-weight-bold">
        <span v-if="scoreText1">
          <span v-html="scoreText1"></span>
          <!--<span v-html="scoreText1"></span>
          <span style="font-weight: bold" v-html="scoreTextResult1"></span>
          <span v-html="scoreText2"></span>
          <span style="font-weight: bold" v-html="scoreTextResult2"></span>-->
        </span>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- Farben für den Bankenscore:
              0-10 #c52d00
              10-20 #ec3c00
              20-30 #f47900
              30-40 #f89e00
              40-50 #fcbf00
              50-60 #e1dc00
              60-70 #bdd000
              70-80 #99c100
              80-90 #4faa2f
              90-100 #00873a
              -->
              <v-layout justify-start>
                <v-flex xs12 md8>
                  <v-card flat>
                    <v-layout row>
                      <v-flex xs12 sm4 md4 lg3 v-if="ring1.value" class="pt-3">
                        <v-card flat>
                          <v-tooltip right content-class="opaqueTT">
                            <template v-slot:activator="{ on }">
                              <v-progress-circular
                                :value="ring1.value"
                                :color="ring1.color"
                                width="15"
                                size="100"
                                v-on="on"
                              >
                                {{ring1.numberBankenscore}}
                              </v-progress-circular>
                            </template>
                            <v-card>
                              <v-card-title>
                                <v-layout row justify-center>
                                  <img :src="'./static/Tooltip_BASCO.png'" height="150px">
                                  <v-layout row wrap class="text-xs-left">
                                    <v-flex xs12>
                                      <v-flex xs12>
                                        <div style="margin-top: 40px; padding-left: 0px">
                                          {{'TOOLTIP_RING_GOOD'| translate}}
                                        </div>
                                      </v-flex>
                                      <v-flex xs12>
                                        <div style="margin-top: 10px; padding-left: 6px">
                                          {{'TOOLTIP_RING_BAD'| translate}}
                                        </div>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-layout>
                              </v-card-title>
                            </v-card>
                          </v-tooltip>
                          <v-card-title class="title font-weight-bold pt-0">
                            <v-spacer></v-spacer>
                            {{ring1.yearBankenscore}}
                            <v-spacer></v-spacer>
                          </v-card-title>

                        </v-card>
                      </v-flex>

                      <v-flex xs12 sm4 md4 lg3 v-if="ring2.yearBankenscore && ring2.yearBankenscore.length > 0" class="pt-3">
                        <v-card class="" flat>
                          <v-tooltip left content-class="opaqueTT">
                            <template v-slot:activator="{ on }">
                              <v-progress-circular
                                :value="ring2.value"
                                :color="ring2.color"
                                width="15"
                                size="100"
                                v-on="on"
                              >
                                {{ring2.numberBankenscore}}
                              </v-progress-circular>
                            </template>
                            <v-card>
                              <v-card-title>
                                <v-layout row justify-center>
                                  <img :src="'./static/Tooltip_BASCO.png'" height="150px">
                                  <v-layout row wrap class="text-xs-left">
                                    <v-flex xs12>
                                      <v-flex xs12>
                                        <div style="margin-top: 40px; padding-left: 0px">
                                          {{'TOOLTIP_RING_GOOD'| translate}}
                                        </div>
                                      </v-flex>
                                      <v-flex xs12>
                                        <div style="margin-top: 10px; padding-left: 6px">
                                          {{'TOOLTIP_RING_BAD'| translate}}
                                        </div>
                                      </v-flex>
                                    </v-flex>
                                  </v-layout>
                                </v-layout>
                              </v-card-title>
                            </v-card>
                          </v-tooltip>
                          <v-card-title class="title font-weight-bold pt-0">
                            <v-spacer></v-spacer>
                            {{ring2.yearBankenscore}}
                            <v-spacer></v-spacer>
                          </v-card-title>

                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-flex xs12  justify-start style="text-align: left; border: 1px; color:#5d615d;" class="pl-2">
                <v-icon>feedback</v-icon> {{'BASCO_MESSAGE' | translate}}
              </v-flex>
            </v-layout>


            <!--
            <StrukturBilanzTable :sortDisabled="true" :maxHeight="80" ref="tabHead" tableName="headTable" edoClassName="kz"></StrukturBilanzTable>
            -->

            <StrukturBilanzTable :tableTooltips='tableTooltips' :sortDisabled="true" :widthSub="40" :heightSub="tableHeightSub" ref="tabKennzahlen"
                                 configSuffix="BS" tableName="total" edoClassName="kz"></StrukturBilanzTable>
          </v-flex>
        </v-layout>
  </v-card>
</template>
<script>
  import Vue from 'vue'
  import StrukturBilanzTable from './StrukturBilanzTable'
  import BtnDownloadExcel from './../../widgets/BtnDownloadExcel'
  import VueMarkdown from 'vue-markdown'
  export default {
    name: 'TabBankenscore',
    components: {StrukturBilanzTable, BtnDownloadExcel, VueMarkdown},
    props: ['balance', 'isPeergroup', 'balanceArray'],
    methods: {
      open: function () {
        Vue.prototype.$eventHub.$emit('OnGetExcelConfig', this.configExcel)
        this.reload()
      },
      onChangeTab: function (tab) {
        console.log('onChangeTab', tab)
      },
      close: function () {
        this.$refs['tabKennzahlen'].close()
      },
      updateRings: function (data) {
        this.scoreTitle = data.infoTitle

        this.ring1.yearBankenscore = data.title
        this.ring1.color = '#' + data.color
        this.ring1.value = Vue.prototype.$api.convertToWaimeaDecimal('f1t', data.value * 10)
        this.ring1.numberBankenscore = Vue.prototype.$api.convertToWaimeaDecimal('f1t', data.value)

        this.ring2.yearBankenscore = data.prevTitle
        this.ring2.color = '#' + data.prevColor
        this.ring2.value = Vue.prototype.$api.convertToWaimeaDecimal('f1t', data.prevValue * 10)
        this.ring2.numberBankenscore = Vue.prototype.$api.convertToWaimeaDecimal('f1t', data.prevValue)
        if (!data.prevValue) {
          this.ring2.yearBankenscore = ''
        }

        this.scoreText1 = data.infoText

        this.nameMother = data.infoRootName
        this.bankenscoreYear = data.infoRootYear
        this.waText = data.infoRootAA
        this.rechtskreisText = data.infoRootRK
      },
      onGetAXData: function (data) {
        Vue.prototype.$api.debug('onGetAXData', data)
      },
      onGetData: function (data) {
        Vue.prototype.$api.debug('Kennzahlen', data)
        this.tableData = data
        Vue.prototype.$api.hideIdle()
        data.tables = []
        data.tables['total'] = data.table
        data.tables['headTable'] = data.headTable

        this.tabs = 'tabAktiva'

        this.updateRings(data.score)


        let i = 0
        while (((this.tableTooltips.crasrow.text.indexOf('\\n') > -1) || (this.tableTooltips.crasrow.text.indexOf('\n') > -1)) && (i < 100)) {
          this.tableTooltips.crasrow.text = this.tableTooltips.crasrow.text.replace('\\n','<br>')
          this.tableTooltips.crasrow.text = this.tableTooltips.crasrow.text.replace("\n",'<br>')
          i++;
        }
        // console.log('4this.tableTooltips.crasrow.text', this.tableTooltips.crasrow.text)
        if (this.$refs['tabKennzahlen'] && this.$refs['tabKennzahlen'].open) {
          this.$refs['tabKennzahlen'].open(data)
        }
        if (this.$refs['tabHead'] && this.$refs['tabHead'].open) {
          this.$refs['tabHead'].open(data)
        }
      },
      reCreateAX: function () {
        console.log('reCreateAX')
        Vue.prototype.$api.getAXSemantics(this.balance, true, this.onGetAXData)
      },
      reload: function () {
        this.tableTooltips = {
          'crasrow': {
            text: Vue.i18n.translate('TOOLTIP_CRAS')
          }
        }
        Vue.prototype.$api.showIdle()
        if (this.isMock) {
          this.onGetData(this.myMockData)
        } else {
          if (this.isPeergroup) {
            Vue.prototype.$api.createBankenscoreDataWithBalanceArray(this.balanceArray, this.onGetData)
          } else {
            Vue.prototype.$api.createBankenscoreDataWithBalance(this.balance, this.onGetData)
            // Vue.prototype.$api.getAXSemantics(this.balance, this.onGetAXData)
          }
        }
      }
    },
    data() {
      return {
        scoreText1: 'Auf der Basis des letzten Jahresabschlusses verfügt das Unternehmen über eine',
        scoreTextResult1: 'gute bis stark befriedigende Bilanzbonität.',
        scoreText2: 'Dies entspricht einem',
        scoreTextResult2: 'relativ geringen Insolvenzrisiko.',
        scoreTitle: 'Der Score basiert auf den Daten des Spitzeninstitus:',
        nameMother: 'Test Name Konzernmutter',
        bankenscoreYear: '2018',
        waText: 'Konzernabschluss',
        rechtskreisText: 'Bankbilanz IFRS 9',
        missingRight: true,
        tableTooltips: {
          'crasrow': {
            text: 'HAllo ich bin es'
          }
        },
        fixedHeight: 100,
        axData: '',
        ring1: {
          color: '#fcbf00',
          value: 48,
          numberBankenscore: '4,8',
          yearBankenscore: '2019',
        },
        ring2: {
          color: '#bed000',
          value: 65,
          numberBankenscore: '6,5',
          yearBankenscore: '2018',
        },
        configExcel: {
          excelSheetStammdaten: 0,
          excelSheetStrukturbilanz: 0,
          excelSheetRohbilanz: 0,
          excelSheetKennzahlen: 1,
          excelSheetBilanzrating: 0,
          excelSheetKDF: 0,
          configName: '',
          type: 'EXCEL-STRUCT'
        },
        tabs: null,
        tab1: 'Rating',
        tab2: 'Kommentar',
        isMock: false,
        tableData: null,
        tableHeightSub: 344,
        myMockData: {"creationLabel":"Erstellt am 05.06.2020 um 15:53","currencyLabel":"Alle absoluten Werte in Tsd. EUR","execTime":"1.43908","module":"banks","clientNr":250,"clientExt":"Bankbilanzen","clientExtSP":"Bankbilanzen","publicDatabase":"Bankbilanzen","clientDatabase":"","currency":2,"currencyDimension":2,"sheetName":"Bankenscore","balance":{"crefoNr":"6070000944","year":2018,"aaNr":1,"rkNr":43,"source":1},"balances":[{"crefoNr":"6070000944","year":2018,"aaNr":1,"rkNr":43,"source":1},{"crefoNr":"6070000944","year":2017,"aaNr":1,"rkNr":43,"source":1},{"crefoNr":"6070000944","year":2016,"aaNr":1,"rkNr":43,"source":1}],"crefoNr":"6070000944","bankName":"Deutsche Bank AG","score":{"title":"Score 2018","color":"FCBF00","value":"5.6","prevTitle":"Score 2017","prevValue":"5.6","prevColor":"FCBF00","infoTitle":"","infoRootName":"","infoRootYear":2018,"infoRootAA":"Einzelabschluss","infoRootRK":"Bankbilanz HGB","infoText":"\rAusreichende finanzielle Stärke,\r höheres Risiko\r "},"headTable":{"name":"","title":"","columns":[{"type":"title","title":"","width":34,"align":"L","headerAlign":"L","format":"T"},{"type":"year","title":2018,"width":15,"align":"R","headerAlign":"R","format":"F1T"},{"type":"year","title":2017,"width":15,"align":"R","headerAlign":"R","format":"F1T"}],"rows":[{"cells":[{"co":"Score"},{"co":"5.6","align":"C","format":"F1T","bgrColor":"FCBF00","fontColor":"000000"},{"co":"5.6","align":"C","format":"F1T","bgrColor":"FCBF00","fontColor":"000000"}],"type":"score"}]},"table":{"name":"","title":"","columns":[{"id":"ID-TITLE","type":"title","title":"Datenfelder","width":48,"align":"L","headerAlign":"L","format":"T"},{"id":"ID-YEAR-2018","type":"year","title":2018,"width":17,"align":"R","headerAlign":"R","format":"F2T"},{"id":"ID-DELTA-PERCENT","type":"delta","title":"Δ%","width":17,"align":"R","headerAlign":"R","format":"F2T","tt":"TOOLTIP_TC_BANKSCORE_DELTA"},{"id":"ID-YEAR-2017","type":"year","title":2017,"width":17,"align":"R","headerAlign":"R","format":"F2T"},{"id":"ID-YEAR-2016","type":"year","title":2016,"width":17,"align":"R","headerAlign":"R","format":"F2T"}],"rows":[{"cells":[{"co":"Income Ratios","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"hdr","height":25,"feed":0,"fontBold":true,"fontSize":9},{"cells":[{"co":"Cost-to-Income Ratio (%)"},{"co":"85.536408741908"},{"co":0},{"co":"85.536408741908"},{"co":"85.536408741908"}],"type":"kz","id":"11","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111112","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Cost-to-Income Excluding Trading Ratio (%)"},{"co":"93.698059821505"},{"co":0},{"co":"93.698059821505"},{"co":"93.698059821505"}],"type":"kz","id":"12","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111113","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"ROA (Return on  assets) (%)"},{"co":"0.048710689279275"},{"co":0},{"co":"0.048710689279275"},{"co":"0.048710689279275"}],"type":"kz","id":"13","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111114","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"ROE (Return on  equity) (%)"},{"co":"0.81771808794521"},{"co":0},{"co":"0.81771808794521"},{"co":"0.81771808794521"}],"type":"kz","id":"14","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111115","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"RORWA (Return on  Risk-weighted Assets) (%)"},{"co":"0.14544498260004"},{"co":0},{"co":"0.14544498260004"},{"co":"0.14544498260004"}],"type":"kz","id":"15","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111116","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"ROA (%) before taxes"},{"co":"0.062167658592354"},{"co":0},{"co":"0.062167658592354"},{"co":"0.062167658592354"}],"type":"kz","id":"16","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111117","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"ROE (%) before taxes"},{"co":"1.1232115095194"},{"co":0},{"co":"1.1232115095194"},{"co":"1.1232115095194"}],"type":"kz","id":"17","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111124","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"RORWA (%) before taxes"},{"co":"0.19522029633442"},{"co":0},{"co":"0.19522029633442"},{"co":"0.19522029633442"}],"type":"kz","id":"18","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111125","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Net Interest Margin (%)"},{"co":"0.40175577971209"},{"co":0},{"co":"0.40175577971209"},{"co":"0.40175577971209"}],"type":"kz","id":"19","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111126","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Bewertung Income Ratios","format":"T"},{"co":3,"display":"score"},{"co":""},{"co":3,"display":"score"},{"co":3,"display":"score"}],"type":"kz","fontSize":9,"height":20},{"cells":[{"co":"Asset Ratios","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"hdr","height":25,"feed":0,"fontBold":true,"fontSize":9},{"cells":[{"co":"NPLs\/ Net Loans to Customers (%)"},{"co":null},{"co":""},{"co":null},{"co":null}],"type":"kz","id":"1","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111118","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"NPLs\/ Risk-weighted Assets (%)"},{"co":null},{"co":""},{"co":null},{"co":null}],"type":"kz","id":"4","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111121","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Reserves\/ Impaired Loans (%)"},{"co":null},{"co":""},{"co":null},{"co":null}],"type":"kz","id":"6","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111123","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Net Write-offs\/ risk-weighted Assets (%)"},{"co":"0.60125787599306"},{"co":0},{"co":"0.60125787599306"},{"co":"0.60125787599306"}],"type":"kz","id":"8","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Risk-weighted Assets\/ Assets (%)"},{"co":"39.438103362512"},{"co":0},{"co":"39.438103362512"},{"co":"39.438103362512"}],"type":"kz","id":"9","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":""},{"co":888562000},{"co":0},{"co":888562000},{"co":888562000}],"type":"kz","id":"100","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Bewertung Asset Ratios","format":"T"},{"co":6,"display":"score"},{"co":""},{"co":6,"display":"score"},{"co":6,"display":"score"}],"type":"kz","fontSize":9,"height":20},{"cells":[{"co":"Capital Ratios","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"hdr","height":25,"feed":0,"fontBold":true,"fontSize":9},{"cells":[{"co":"Total Equity\/ Total Assets (%)"},{"co":"7.2293210828282"},{"co":0},{"co":"7.2293210828282"},{"co":"7.2293210828282"}],"type":"kz","id":"20","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"CET1 Leverage Ratio (%)"},{"co":"4.3"},{"co":0},{"co":"4.3"},{"co":"4.3"}],"type":"kz","id":"27","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Tier 1 Common Capital (CET1) Ratio (%) (phased-in)"},{"co":"13.6"},{"co":0},{"co":"13.6"},{"co":"13.6"}],"type":"kz","id":"21","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Tier 1 Ratio (%) (phased-in)"},{"co":"15.7"},{"co":0},{"co":"15.7"},{"co":"15.7"}],"type":"kz","id":"22","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Total Capital Ratio (%) (phased-in)"},{"co":"17.5"},{"co":0},{"co":"17.5"},{"co":"17.5"}],"type":"kz","id":"23","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Bewertung Capital Ratios","format":"T"},{"co":6,"display":"score"},{"co":""},{"co":6,"display":"score"},{"co":6,"display":"score"}],"type":"kz","fontSize":9,"height":20},{"cells":[{"co":"Liquidity Ratios","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"hdr","height":25,"feed":0,"fontBold":true,"fontSize":9},{"cells":[{"co":"Liquidity Coverage Ratio (%)"},{"co":"140.37"},{"co":0},{"co":"140.37"},{"co":"140.37"}],"type":"kz","id":"32","bbnr":7,"bgrColor":"FFFFFF","fontSize":9,"fontColor":"111127","fontBold":false,"feed":0,"height":20},{"cells":[{"co":"Bewertung Liquidity Ratios","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"kz","fontSize":9,"height":20},{"cells":[{"co":"CRAS (1-10)","format":"T"},{"co":""},{"co":""},{"co":""},{"co":""}],"type":"hdr","height":25,"feed":0,"fontBold":true,"fontSize":9,"crasrow":true},{"cells":[{"co":"CRAS","format":"T"},{"co":"2.1","format":"F1T"},{"co":""},{"co":"2.1","format":"F1T"},{"co":"2.1","format":"F1T"}],"type":"kz","fontSize":9,"height":20},{"cells":[{"co":"Bewertung CRAS","format":"T"},{"co":9,"display":"score"},{"co":""},{"co":9,"display":"score"},{"co":9,"display":"score"}],"type":"kz","fontSize":9,"height":20}]}}
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>

  .opaqueTT {
    opacity: 1.0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/module/akte/TabBankenscore.vue